
import 'jquery'
import 'bootstrap/js/dist/collapse'
import 'bootswatch/dist/superhero/bootstrap.css'
import './config/fa'

import App from './App.vue'

import Vue from 'vue'

import store from './state/state'

import VueRouter from 'vue-router'
import routes from './config/routes'

import VueI18n from 'vue-i18n'
import i18n_config from './config/i18n'

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VueI18n);


const router = new VueRouter({routes});
const i18n = new VueI18n(i18n_config);
new Vue({
  render: h => h(App),
  store, router,i18n
}).$mount('#app')
